/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TranslationIcon = /*#__PURE__*/ createSvgIcon(
  'TranslationIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M12.667 15.563l-.69 1.946a.731.731 0 01-.276.356.738.738 0 01-.43.135.713.713 0 01-.636-.333.737.737 0 01-.072-.709l2.979-7.937a.903.903 0 01.3-.375.733.733 0 01.44-.146h.602c.16 0 .307.049.44.146a.903.903 0 01.301.375l3 7.958a.69.69 0 01-.091.698.745.745 0 01-.631.323.747.747 0 01-.455-.146.794.794 0 01-.281-.375l-.671-1.916h-3.83zm-5.167-4l-3.458 3.416a.681.681 0 01-.521.219.758.758 0 01-.521-.24.718.718 0 01-.23-.52c0-.195.077-.369.23-.521l3.48-3.438c-.5-.528-.966-1.076-1.397-1.646-.43-.57-.805-1.187-1.125-1.854h1.709c.25.445.5.823.75 1.136.25.312.61.732 1.083 1.26a19.05 19.05 0 001.458-1.823A9.194 9.194 0 0010.042 5.5H1.75a.728.728 0 01-.534-.214A.72.72 0 011 4.754c0-.21.072-.39.216-.535A.72.72 0 011.75 4h5V2.75c0-.212.071-.39.214-.534A.72.72 0 017.496 2c.21 0 .39.072.535.216a.72.72 0 01.219.534V4h5c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-1.616a9.86 9.86 0 01-1.28 2.656 21.728 21.728 0 01-1.833 2.323l1.896 1.875-.584 1.542L7.5 11.562zm5.667 2.624H16l-1.375-3.937-1.458 3.938z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TranslationIcon;
